import { useQuery } from '@tanstack/react-query';
import { fetcher } from 'src/api/fetcher';
import { API_RESOURCES } from 'src/utils/constants';
import { getUuid } from 'src/utils/url';

export const useToolingStock = (toolingStockUri, options = {}) => {
  const { enabled = true, ...queryOptions } = options;
  return useQuery({
    queryKey: ['tooling-stock', 'tooling-stock-by-uri', toolingStockUri],
    queryFn: () => fetcher(`${API_RESOURCES.TOOLING_STOCK}/${getUuid(toolingStockUri)}`),
    enabled: Boolean(enabled && toolingStockUri),
    refetchOnWindowFocus: false,
    ...queryOptions,
  });
};

export const useToolingType = (toolingTypeUri, options = {}) => {
  const { enabled = true, ...queryOptions } = options;
  return useQuery({
    queryKey: ['tooling-type', 'tooling-type-by-uri', toolingTypeUri],
    queryFn: () => fetcher(`${API_RESOURCES.TOOLING_TYPE}/${getUuid(toolingTypeUri)}`),
    enabled: Boolean(enabled && toolingTypeUri),
    refetchOnWindowFocus: false,
    ...queryOptions,
  });
};
